import { render, staticRenderFns } from "./Factory.vue?vue&type=template&id=24b35fd6&scoped=true"
import script from "./Factory.vue?vue&type=script&lang=js"
export * from "./Factory.vue?vue&type=script&lang=js"
import style0 from "./Factory.vue?vue&type=style&index=0&id=24b35fd6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24b35fd6",
  null
  
)

export default component.exports